/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Two_Fa_Scan_Qr_CodeInputs */

const en_two_fa_scan_qr_code = /** @type {(inputs: Two_Fa_Scan_Qr_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan this QR code`)
};

const nl_two_fa_scan_qr_code = /** @type {(inputs: Two_Fa_Scan_Qr_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan deze QR-code`)
};

/**
* | output |
* | --- |
* | "Scan this QR code" |
*
* @param {Two_Fa_Scan_Qr_CodeInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const two_fa_scan_qr_code = /** @type {((inputs?: Two_Fa_Scan_Qr_CodeInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Two_Fa_Scan_Qr_CodeInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_two_fa_scan_qr_code(inputs)
	return en_two_fa_scan_qr_code(inputs)
});